var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"typography-picker"},[_c('BrandTypographyFont',{attrs:{"value":_vm.value,"label":_vm.label},on:{"update":_vm.openTypographyEditPanel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }